export const ADD_REPORTITEM_FAIL = "ADD_REPORTITEM_FAIL";
export const ADD_REPORTITEM_REQUEST = "ADD_REPORTITEM_REQUEST";
export const ADD_REPORTITEM_SUCCESS = "ADD_REPORTITEM_SUCCESS";
export const SAVE_FILLED_REPORTITEM = "SAVE_FILLED_REPORTITEM";
export const ITEM_DETAILS_REQUEST = " ITEM_DETAILS_REQUEST";
export const ITEM_DETAILS_SUCCESS = "ITEM_DETAILS_SUCCESS";
export const ITEM_DETAILS_FAIL = "ITEM_DETAILS_FAIL";
export const ALLRPTITEM_LIST_REQUEST = "ALLRPTITEM_LIST_REQUEST";
export const ALLRPTITEM_LIST_SUCCESS = "ALLRPTITEM_LIST_SUCCESS";
export const ALLRPTITEM_LIST_FAIL = "ALLRPTITEM_LIST_FAIL";
